import React, { useState } from 'react';
import PageLoadingSpinner from '../components/PageLoadingSpinner';
import {
  TRADEMARK,
  TRADEMARK_ALT,
  TRADEMARK_CAPTION,
  TRADEMARK_FACTS,
  TRADEMARK_SUMMARY,
} from '../config/trademark';
import {
  TEKNOGIRISIM,
  TEKNOGIRISIM_ALT,
  TEKNOGIRISIM_CAPTION,
  TEKNOGIRISIM_FACTS,
  TEKNOGIRISIM_SUMMARY,
  isTeknogirisimValid,
} from '../config/teknogirisim';

function AboutPage() {
  const [loading] = useState(false); // Remove setLoading

  return (
    <>
      <PageLoadingSpinner show={loading} fullscreen />
      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-12 col-md-8 col-lg-6">
            <h2 className="mb-4 text-center">Hakkımızda</h2>
            <p>
              <b>Katip Otomasyonu</b>, Arkaya Arge Yazılım İnşaat Ticaret Ltd.Şti. tarafından Isparta'da kurulmuş ve geliştirilmektedir. Şirketimiz, iş sağlığı ve güvenliği alanında dijitalleşmeyi ve otomasyonu destekleyen yenilikçi SaaS (Software as a Service) çözümler üretmeye odaklanmıştır.
            </p>
            <p>
              Amacımız, İSG-Katip kullanıcılarının iş süreçlerini kolaylaştırmak, zamandan tasarruf etmelerini sağlamak ve mevzuata tam uyumlu, güvenli, hızlı ve kullanıcı dostu yazılımlar sunmaktır. Katip Otomasyonu, işyeri hekimi, iş güvenliği uzmanı ve diğer sağlık personeli atamaları, sözleşme yönetimi ve raporlama gibi süreçleri otomatikleştirerek kurumların verimliliğini artırır.
            </p>

            {/* Marka tescil künyesi. BELGE SAYFADA GÖRÜNÜR, bağlantının arkasında
                değil (kullanıcı kararı 14.09.2026): "tescillidir" diyen bir cümlenin
                ispatı için kullanıcıyı yeni sekmeye yollamak, ispatı hiç görmeyen
                kullanıcı üretiyordu. PDF indirme bağlantısı YOK (kullanıcı kararı
                14.09.2026): ziyaretçinin belgeyi indirmesine gerek yok.
                Künye verileri `config/trademark.js`te — Telif Hakkı sayfası da
                AYNI kaynaktan okur. */}
            <div className="card shadow-sm mt-4">
              <div className="card-body">
                <h3 className="h6 text-uppercase text-muted mb-3" style={{ letterSpacing: '.05em' }}>
                  Marka Tescil Künyesi
                </h3>
                <p className="small">{TRADEMARK_SUMMARY}</p>
                <dl className="row small mb-3">
                  {TRADEMARK_FACTS.map(([label, value]) => (
                    <React.Fragment key={label}>
                      <dt className="col-sm-5 fw-normal text-muted">{label}</dt>
                      <dd className="col-sm-7 fw-semibold mb-1">{value}</dd>
                    </React.Fragment>
                  ))}
                </dl>
                <figure className="mb-0 text-center">
                  <img
                    src={TRADEMARK.image}
                    alt={TRADEMARK_ALT}
                    className="img-fluid rounded border"
                    width={TRADEMARK.imageWidth}
                    height={TRADEMARK.imageHeight}
                    style={{ maxWidth: '340px', width: '100%', height: 'auto' }}
                    loading="lazy"
                  />
                  <figcaption className="small text-muted mt-2">{TRADEMARK_CAPTION}</figcaption>
                </figure>
              </div>
            </div>

            {/* Teknogirişim Rozeti — marka künyesinin HEMEN ALTINDA, aynı kart
                biçiminde. Belge SAYFADA görsel olarak basılır; PDF indirme bağlantısı
                yoktur. Veriler `config/teknogirisim.js`te; rozetin süresi dolunca
                kart çizilmez. */}
            {isTeknogirisimValid() && (
              <div className="card shadow-sm mt-4">
                <div className="card-body">
                  <h3 className="h6 text-uppercase text-muted mb-3" style={{ letterSpacing: '.05em' }}>
                    Teknogirişim Rozeti
                  </h3>
                  <p className="small">{TEKNOGIRISIM_SUMMARY}</p>
                  <dl className="row small mb-3">
                    {TEKNOGIRISIM_FACTS.map(([label, value]) => (
                      <React.Fragment key={label}>
                        <dt className="col-sm-5 fw-normal text-muted">{label}</dt>
                        <dd className="col-sm-7 fw-semibold mb-1">{value}</dd>
                      </React.Fragment>
                    ))}
                  </dl>
                  <figure className="mb-0 text-center">
                    <img
                      src={TEKNOGIRISIM.image}
                      alt={TEKNOGIRISIM_ALT}
                      className="img-fluid rounded border"
                      width={TEKNOGIRISIM.imageWidth}
                      height={TEKNOGIRISIM.imageHeight}
                      style={{ width: '100%', height: 'auto' }}
                      loading="lazy"
                    />
                    <figcaption className="small text-muted mt-2">{TEKNOGIRISIM_CAPTION}</figcaption>
                  </figure>
                </div>
              </div>
            )}
          </div>
        </div>
        <div className="row g-4 mb-4 justify-content-center">
          <div className="col-md-6">
            <div className="card h-100 shadow-sm">
              <div className="card-body d-flex flex-column align-items-center text-center">
                <img src="/yusuf_kaya.png" alt="Yusuf Kaya" className="rounded-circle mb-3" style={{ width: 80, height: 80, objectFit: 'cover' }} />
                <h5 className="card-title mb-1">Yusuf Kaya</h5>
                <p className="mb-1">Founder | DevOps & Cloud Engineer</p>
                <div className="d-flex justify-content-center align-items-center gap-3 mb-2">
                  <a href="https://www.linkedin.com/in/yusufkayatr96/" target="_blank" rel="noopener noreferrer" style={{ display: 'flex', alignItems: 'center' }}>
                    <img src="https://upload.wikimedia.org/wikipedia/commons/8/81/LinkedIn_icon.svg" alt="LinkedIn" style={{ width: 32, height: 32, display: 'block' }} />
                  </a>
                  <a href="https://medium.com/@yusufkayatr96" target="_blank" rel="noopener noreferrer" style={{ display: 'flex', alignItems: 'center' }}>
                    <img src="https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/medium.svg" alt="Medium" style={{ width: 32, height: 32, background: '#fff', borderRadius: '50%', padding: 2, display: 'block' }} />
                  </a>
                  <a href="mailto:yusuf@katipotomasyonu.com" target="_blank" rel="noopener noreferrer" style={{ display: 'flex', alignItems: 'center' }}>
                    <i className="bi bi-envelope-fill" style={{ fontSize: 32, color: '#0d6efd', verticalAlign: 'middle', display: 'block' }}></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row g-4 justify-content-center">
          <div className="col-md-6">
            <div className="mt-4 p-3 rounded-3" style={{
              background: 'linear-gradient(135deg, #dc3545 0%, #c82333 100%)',
              boxShadow: '0 4px 15px rgba(220, 53, 69, 0.3)'
            }}>
              <p className="mb-0 text-white d-flex align-items-center justify-content-center gap-2" style={{fontSize: '0.95rem', fontWeight: '500'}}>
                <a href="mailto:info@katipotomasyonu.com" className="text-white text-decoration-none" title="E-posta gönder">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16" style={{cursor: 'pointer'}}>
                    <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2zm13 2.383-4.708 2.825L15 11.118V5.383zM14.803 12 10.2 8.911l-1.428.857a.5.5 0 0 1-.544 0L6.8 8.911 2.197 12A1 1 0 0 0 3 13h10a1 1 0 0 0 .803-1zM1 11.118l4.708-2.91L1 5.383v5.735z"/>
                  </svg>
                </a>
                <span>
                  Genel destek için: <strong>info@katipotomasyonu.com</strong>
                </span>
              </p>
            </div>
          </div>
        </div>
        <div className="row g-4 justify-content-center mt-4">
          <div className="col-12 col-md-8 col-lg-6 text-center">
            <a href="https://arkaya.com.tr" target="_blank" rel="noopener noreferrer">
              <img 
                src="/arkaya-logo.png" 
                alt="Arkaya Arge Yazılım" 
                className="img-fluid"
                style={{ 
                  maxWidth: '100%',
                  width: '600px',
                  height: 'auto', 
                  cursor: 'pointer',
                  transition: 'opacity 0.3s ease',
                  opacity: 0.8
                }}
                onMouseEnter={(e) => e.target.style.opacity = 1}
                onMouseLeave={(e) => e.target.style.opacity = 0.8}
              />
            </a>
          </div>
        </div>
      </div>
    </>
  );
}

export default AboutPage;
